import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Container, Dropdown, Menu } from 'semantic-ui-react';

import AuthButton from './pages/Sign/auth-button';
import Customer from './pages/customer/index';
import Home from './pages/Home/index';
import PrivateRoute from './pages/Sign/private-route';
import Sale from './pages/sale/Sale';
import SignIn from './pages/Sign/signin';
import SignOut from './pages/Sign/signout';

function App() {
  return (
    <Router>
      <div>
        <Menu>
          <Menu.Item as={Link} to="/">Home</Menu.Item>

          <Dropdown item text="Clientes" >
             <Dropdown.Menu>
              <Dropdown.Item>
               <Link to="/customers" className="menu-item-customers">Cadastro De Cliente</Link>
              </Dropdown.Item>
             </Dropdown.Menu>
          </Dropdown>

          <Dropdown item text="Vendas" >
             <Dropdown.Menu>
              <Dropdown.Item>
               <Link to="/sales" className="menu-item-sales">Cadastro De Vendas</Link>
              </Dropdown.Item>
             </Dropdown.Menu>
          </Dropdown>

          <Menu.Item position="right">
            <AuthButton />
          </Menu.Item>

        </Menu>
      </div>
      <Container >
        <Switch>
          <PrivateRoute path="/customers"><Customer /></PrivateRoute>
          <PrivateRoute path="/sales"><Sale /></PrivateRoute>
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/signout" component={SignOut} />
          <Route path="/" exact component={Home}/>
          <Route path="*" component={() => <h1>Page not found</h1>} />
        </Switch>
      </Container>
    </Router>
  );
}

export default App;